module.exports = __webpack_public_path__ + "static/media/build_muscle_img.f9bf304a.svg";